// extracted by mini-css-extract-plugin
export default {"header":"T1402t1HVyG2R_LGQ5pJ"};